import { IReferenceAssociativeLanguage } from 'legacy/lut/store/state'

import { checkCache, readFromCache, saveToCache } from 'core/classes/cache/Cache'
import StorageKeys from 'core/classes/cache/StorageKeys'
import { CrudHelper } from 'core/types/helpers/CrudHelper'

export const fetchAssociativeLanguages = async (): Promise<IReferenceAssociativeLanguage[]> => {
  const needRefresh = checkCache(StorageKeys.associativeLanguages)
  if (needRefresh) {
    const crud = new CrudHelper(102, 'CountryLanguages')
    const response = (await crud.read()) || {}

    let result: IReferenceAssociativeLanguage[] = []
    if (response && response['Data']) {
      result = response['Data'].map((element: any) => ({
        value: element.languageCode,
        name: element.languageCode,
        CountryCode: element.countryCode,
      }))
    }
    saveToCache(StorageKeys.associativeLanguages, result, true)
    return result
  } else {
    return readFromCache(StorageKeys.associativeLanguages)
  }
}
